export default __webpack_public_path__ + "static/user_friendly_access-2502a233a244d211ea09c2b45a31f890.svg";